import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createTag = async (formValues) => {
  const formData = new FormData();
  formData.append("TagName", formValues.TagName);
  formData.append("TagURL", formValues.TagURL);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("Featured", formValues.Featured.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ImageURLFile) {
    formData.append("ImageURLFile", formValues.ImageURLFile);
  }
  const response = await axiosInstance.post("product/tag", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};
export const updateTag = async (formValues) => {
  const formData = new FormData();
  formData.append("Id", formValues.Id);
  formData.append("TagName", formValues.TagName);
  formData.append("TagURL", formValues.TagURL);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("Featured", formValues.Featured.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ImageURLFile) {
    formData.append("ImageURLFile", formValues.ImageURLFile);
  } else {
    formData.append("ImageURLFile", null);
  }
  const response = await axiosInstance.put("product/tag", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};

export const fetchTags = async () => {
  const response = await axiosInstance.get("product/tag", { headers });
  return response.data;
};

export const fetchTagDropdowns = async () => {
  const response = await axiosInstance.get("product/tag/dropdown", {
    headers,
  });
  return response.data;
};

export const fetchTagById = async (id) => {
  const response = await axiosInstance.get(`product/tag/${id}`, {
    headers,
  });
  return response.data;
};

export const publishTag = async (id) => {
  return await await axiosInstance.patch(`product/tag/${id}/publish`, {
    headers,
  });
};

export const unPublishTag = async (id) => {
  return await await axiosInstance.patch(`product/tag/${id}/unpublish`, {
    headers,
  });
};

export const markTagFeatured = async (id) => {
  return await await axiosInstance.patch(`product/tag/${id}/featured`, {
    headers,
  });
};

export const markTagUnFeatured = async (id) => {
  return await await axiosInstance.patch(`product/tag/${id}/unfeatured`, {
    headers,
  });
};

export const deleteTag = async (id) => {
  return await axiosInstance.delete(`product/tag/${id}`, { headers });
};
